<div class="plan-expansion-body">
    <div  class="sorting-block d-flex flex-row align-items-end justify-content-between p-24 flex-wrap gap-20">
        <div #formatContainer class="d-flex flex-row align-items-end gap-8">
            <div class="button-group gap-8 flex-1">
                @for (item of selectedFormatList(); track item.value; let index = $index) {
                <button [ngClass]="{'active': item.isSelected, 'text-gray-9': isFormatEnabled() }" [disabled]="!isFormatEnabled()"
                    (click)="selectedStyle(index)" mat-button mat-stroked-button color="dark" class="button-default custom-format-icons"
                    [title]="item.title">
                    <i [ngClass]="item.iconClass"></i>
                </button>
                }
                <button [disabled]="!isFormatEnabled() || isAnyFormatApplied()" mat-button mat-flat-button color="primary" (click)="applyFormat()">
                    Apply
                </button>
                <button [disabled]="!isFormatEnabled()" mat-button mat-stroked-button color="dark" (click)="cancel()">
                    Cancel
                </button>
            </div>
        </div>

        <div #saveCancelContainer class="d-flex flex-row gap-8">
            @if (scheduleDetails().submodule) {
            <button (click)="resetSchedule()" [disabled]="isSyncCall()" title="Reset to Default" color="secondary" mat-button mat-flat-button>
                <i class="fa-solid fa-rotate-right fa-flip-horizontal"></i> Reset
            </button>
            }
            <button (click)="deleteSchedule(DIALOG_TYPES.SCHEDULE)" [disabled]="isSyncCall()" title="Delete Schedule" color="error" mat-button
                mat-stroked-button>
                <span class="flexbox-row gap-8">
                    <i class="fa-regular fa-trash-can"></i>
                    Delete
                </span>

            </button>
            <button [disabled]="(!isSaveEnabled() || saveChanges().isDisable) && !isTotalHideDesc()" title="Save Changes" color="primary" mat-button mat-flat-button
                (click)="saveSchedule()">
                <span class="flexbox-row gap-8">
                    <i class="fa-regular fa-floppy-disk fs-18"></i> Save
                </span>
            </button>
        </div>
    </div>
</div>

<div  class="flex-1 p-4 pt-0 overflow-hidden template-block-main" >
    <div class="card overflow-auto w-100" id="grid" style="max-height:100%;" (click)="onEditMode()" cdkScrollable [ngClass]="{'view-mode-card': scheduleDetails().disabled }">
        <div #gridContainer class="flex-table fixed-header hover-action" (click)="onEditMode()" [title]="scheduleDetails().disabled ? 'Click to edit' : ''" >
            <div class="flex-table-header fixed-top" appSpin [spinnerConfig]="spinnerConfig()"
                style="min-width:1200px;">
                <p class="ft-header-cell" style="width: 40px; max-width: 40px;">
                </p>
                <p class="ft-header-cell border-start" style="width: 80px; max-width: 80px;">
                </p>
                <p class="ft-header-cell border-start">
                    <span>{{scheduleDetails().schedules.length > 1 ? scheduleDetails()?.name :
                        scheduleDetails()?.schedules[0]?.name }}</span>
                    @if (scheduleDetails().schedules.length > 1) {
                    <button mat-button class="button-text ms-2"
                        (click)="onExpandOrCollapsed(scheduleDetails().isCollapse ? InputOutputEmitter.EXPAND : InputOutputEmitter.COLLAPSED)"
                        title="{{scheduleDetails().isCollapse ? 'Expand All' : 'Collapse All'}}">
                        <i class="fa-regular fs-15"
                            [ngClass]="{'fa-arrows-to-line': !scheduleDetails().isCollapse, 'fa-arrows-from-line': scheduleDetails().isCollapse }"></i>
                    </button>
                    }
                </p>
                @for (column of scheduleDetails().columns; track column.id; let colIndex = $index) {
                <p class="ft-header-cell d-flex justify-content-end gap-8 border-start"
                    style="width: 220px; max-width: 220px;">
                    @if (selectedIndex().defaultDateFormat) {
                    <span class="d-flex align-items-end" [ngClass]="{'flex-column': !(selectedIndex().defaultDateFormat === 'short') , 'flex-row gap-8': (selectedIndex().defaultDateFormat === 'short')}" >
                        <span *ngIf="!(selectedIndex().defaultDateFormat === 'year')">{{
                            engagementDetails().engagementDetails.yearEnd | appCountableTimeZone:
                            (selectedIndex().defaultDateFormat === 'long' ? 'MMMM d' : 'MMM d'):'UTC': (column.type ===
                            'PY') }}</span>

                        <span>{{ engagementDetails().engagementDetails.yearEnd | appCountableTimeZone:'yyyy':'UTC'
                            :(column.type === 'PY') }}</span>
                    </span>
                    }

                    <button mat-button class="button-text hover-action-item" (click)="updateEngagementSchedule({colIndex: colIndex})"
                        [matMenuTriggerFor]="columnFormatOptions">
                        <i class="fa fa-ellipsis-vertical fs-16"></i>
                    </button>
                </p>
                }
            </div>
            @for (schedule of scheduleDetails().schedules; track schedule.id; let groupIndex = $index) {
            <!--            header start here-->
            @if (scheduleDetails().schedules.length > 1) {
            <div class="flex-table-header" style="min-width:1200px;">
                <p class="ft-header-cell" style="width: 40px; max-width: 40px;">
                </p>
                <p class="ft-header-cell border-start" style="width: 80px; max-width: 80px;">
                </p>
                <p class="ft-header-cell border-start">
                    <span>{{ schedule.name }}</span>
                </p>
            </div>
            }
            <!--           header end here -->
            <!--            table body starts here-->
            <div cdkDropList (cdkDropListDropped)="onDrop($event, groupIndex)" class="flex-table-body h-100" (click)="onEditMode()">
                @for (row of schedule.rows; track row.id; let rowIndex = $index) {
                    @if (!row.isDeleted) {
                        <div class="ft-row button-row row-highlight {{scheduleDetails().disabled ? 'disabled' : ''}}" cdkDrag
                             [ngClass]="{'row-highlight-checked': row.isChecked}" >
                            <p class="dragable-icon ft-cell" style="width: 40px; max-width: 40px;" cdkDragHandle>
                                <i class="fa-solid fa-grip-dots-vertical fs-16 hover-action-item"></i>
                            </p>
                            <p class="ft-cell border-start text-center" style="width: 80px; max-width: 80px;">
                        <span class="d-flex gap-10 align-items-center ">
                            <mat-checkbox [checked]="row.isChecked"
                                          (change)="onChangeCheckBox($event, groupIndex, rowIndex)"> </mat-checkbox>
                            <button mat-button class="button-text"
                                    (click)="updateEngagementSchedule({groupIndex: groupIndex, rowIndex: rowIndex})"
                                    [matMenuTriggerFor]="matRowKebabMenu" [matMenuTriggerData]="{row: row}">
                                <i class="fa fa-ellipsis-vertical fs-16"></i>
                            </button>
                        </span>
                            </p>
                            <p class="ft-cell border-start">
                                @if (row.type === rowTypes.TEXT) {
                                    <mat-form-field class="fixed-label label-none w-100 icon-form-after action-2 {{row.classNames}}" floatLabel="always">
                                        <textarea [ngClass]="{'bgColorDisabled': scheduleDetails().disabled }"  matInput [value]="row.accountName"
                                                  (input)="updateValues($event, 'accountName',groupIndex, rowIndex)"
                                                  placeholder="Enter Text Here" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" class="pe-2"></textarea>
                                    </mat-form-field>
                                } @else {
                                    <span class="d-flex align-items-center gap-10">
                            @if (!row.isHide) {
                                <mat-form-field class="fixed-label label-none w-100 col-des"
                                                [ngClass]="{'px-3': row.type === rowTypes.SUBROW}" floatLabel="always">
                                <input  class="cash-field {{row.type === rowTypes.SUBTOTAL ? 'fw-semibold' : row.classNames}}" [ngClass]="{'bgColorDisabled': scheduleDetails().disabled }" matInput type="text" [value]="row.accountName"
                                       (input)="updateValues($event, 'accountName',groupIndex, rowIndex)"
                                       placeholder="Enter Description" >
                            </mat-form-field>
                            }
                                        @if (!(rowTypes.SUBTOTAL === row.type)) {
                                            <mat-form-field floatLabel="always"
                                                            class="fixed-label label-none w-100 icon-form-before col-search">
                                <mat-label>Search</mat-label>
                                <input [ngClass]="{'bgColorDisabled': scheduleDetails().disabled }" matInput type="text" placeholder="Search"
                                       [matMenuTriggerFor]="matSearchForm"  [formControl]="searchControl" (input)="searchRecords($event)"
                                       [matMenuTriggerData]="{groupIndex: groupIndex, rowIndex:rowIndex}"
                                       autocomplete="off" maxlength="25">
                                <span matPrefix>
                                    <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                                </span>
                            </mat-form-field>
                                        }
                        </span>
                                }

                            </p>
                            @for (column of scheduleDetails().columns; track column.id;) {
                                @if (!(row.type === rowTypes.TEXT)) {
                                    <p class="ft-cell border-start text-right" style="width: 220px; max-width: 220px;">
                                        <mat-form-field class="fixed-label label-none w-100 date-col" floatLabel="always">
                                            <input [ngClass]="{'bgColorDisabled': scheduleDetails().disabled }" matInput [type]="scheduleDetails().disabled ? 'text': 'number'" step="1" [disabled]="scheduleDetails().disabled ? false : (row.type === rowTypes.SUBTOTAL)"
                                                   (input)="updateValues($event,(column.type === 'CY' ? 'cyOriginalAmount' : 'pyOriginalAmount'), groupIndex, rowIndex)"
                                                   class="matTypeNumber {{column.classNames}} {{row.classNames}}"
                                                   [value]="scheduleDetails().disabled ? ((column.type === 'CY' ? row.cyOriginalAmount : row.pyOriginalAmount) | formattedNumber) : (column.type === 'CY' ? row.cyOriginalAmount : row.pyOriginalAmount)">
                                        </mat-form-field>
                                    </p>
                                } @else {
                                    <p class="ft-cell text-right" style="width: 220px; max-width: 220px;"></p>
                                }
                            }
                        </div>
                    }
                }

                <!-- Add new row starts here -->
                <div class="ft-row button-row">
                    <p class="ft-cell" style="width: 40px; max-width: 40px;">

                    </p>
                    <p class="ft-cell border-start text-center" style="width: 80px; max-width: 80px;">

                    </p>
                    <p class="ft-cell border-start">
                        <button (click)="cancel()" [matMenuTriggerFor]="matAddNewRow"
                            [matMenuTriggerData]="{groupIndex: groupIndex}" color="dark"
                            mat-button mat-stroked-button>
                            <i class="fa-regular fa-plus"></i>Add Row <i class="fa-regular fa-angle-down"></i>
                        </button>
                    </p>
                    <p class="ft-cell border-start text-right" style="width: 220px; max-width: 220px;">

                    </p>
                    <p class="ft-cell border-start text-right" style="width: 220px; max-width: 220px;">

                    </p>
                </div>
                <!--                new row end here-->
            </div>
            <!--table body ends here-->

            }

            @if(scheduleDetails().schedules.length){
            <div class="ft-row button-row flex-table-footer" style="position: sticky; bottom: 0; z-index: 9;">
                <p class="ft-cell" style="width: 40px; max-width: 40px;">

                </p>

                <p class="ft-cell border-start text-center" style="width: 80px; max-width: 80px;">
                    <span class="d-flex gap-10 align-items-center">
                        <button [title]="scheduleDetails().isTotalHide ? 'Unhide' : 'Hide'" mat-button class="button-text" (click)="hideDescOrTotal('HIDE')">
                            <i
                                class="fa-regular fs-16 hover-action-item {{scheduleDetails().isTotalHide ? 'fa-eye-slash' : 'fa-eye' }}"></i>
                        </button>
                        @if (!scheduleDetails().isTotalHide){
                            <button mat-button class="button-text" [matMenuTriggerFor]="matRowKebabMenu"
                                    [matMenuTriggerData]="{row: {type: rowTypes.TOTAL, isHide: this.scheduleDetails().isTotalDescHide }}">
                            <i class="fa fa-ellipsis-vertical fs-16 hover-action-item"></i>
                        </button>
                        }
                    </span>

                </p>
                <p class="ft-cell border-start" style="font-weight: bold;">
                    @if (!scheduleDetails().isTotalHide){
                        {{ scheduleDetails().isTotalDescHide ? '' : 'Total' }}
                    }
                </p>
                @if (hasCYColumn()) {
                <p class="ft-cell text-right border-start" style="width: 220px; max-width: 220px;">
                    @if (!scheduleDetails().isTotalHide) {
                    <mat-form-field class="fixed-label label-none w-100 date-col total-col" floatLabel="always">
                        <input matInput type="text" class="{{hasCYColumnClassName()}}" [value]="scheduleDetails().disabled ? (totalValues().cyTotal | formattedNumber) : totalValues().cyTotal">
                    </mat-form-field>
                    }

                </p>
                }
                @if (hasPYColumn()) {
                <p class="ft-cell text-right border-start" style="width: 220px; max-width: 220px;">
                    @if (!scheduleDetails().isTotalHide) {
                    <mat-form-field class="fixed-label label-none w-100 date-col total-col" floatLabel="always">
                        <input matInput type="text" class="{{hasPYColumnClassName()}}" [value]="scheduleDetails().disabled ? (totalValues().pyTotal | formattedNumber) : totalValues().pyTotal">
                    </mat-form-field>
                    }

                </p>
                }

            </div>
                @if (scheduleDetails().submodule) {
                    <div class="ft-row button-row flex-table-footer" style="position: sticky; bottom: 0; z-index: 9;">
                        <p class="ft-cell" style="width: 40px; max-width: 40px;">

                        </p>

                        <p class="ft-cell" style="width: 80px; max-width: 80px;">

                        </p>
                        <p class="ft-cell" style="font-weight: bold;">
                        </p>
                        @if (hasCYColumn()) {
                            <p class="ft-cell text-right cross-check-total pe-20" style="width: 220px; max-width: 220px;">
                                {{ ((scheduleDetails().cyTotal - totalValues().cyTotal) == 0) ? '' : (scheduleDetails().cyTotal - totalValues().cyTotal) |  formattedNumber }}
                            </p>
                        }
                        @if (hasPYColumn()) {
                            <p class="ft-cell text-right cross-check-total previous-year-num" style="width: 220px; max-width: 220px;">
                                {{ ((scheduleDetails().pyTotal - totalValues().pyTotal) == 0) ? '' : (scheduleDetails().pyTotal - totalValues().pyTotal) |  formattedNumber }}
                            </p>
                        }
                    </div>
                }
            }
        </div>
    </div>
</div>


<!--row kebab menu-->
<mat-menu #matRowKebabMenu="matMenu">
    <ng-template matMenuContent let-aliasMenuItems="row">
        @for (menu of rowKebabMenu; track menu.key; let rowIndex = $index) {
        @if (aliasMenuItems.type === rowTypes.TOTAL) {
        @if (menu.key === 'hide') {
        <button mat-menu-item (click)="hideDescOrTotal('DESC')">
            <i
                class="fa-regular {{((menu.key === 'hide' && scheduleDetails().isTotalDescHide ) ? 'fa-eye-slash' : menu.iconClass)}}"></i>
            {{ (menu.key === 'hide' && scheduleDetails().isTotalDescHide) ? 'Show Total Desc' : 'Hide Total Desc' }}

        </button>
        }
        } @else if (aliasMenuItems.type === rowTypes.SUBTOTAL && (menu.key === 'hide' || menu.key === 'delete')) {
        <button mat-menu-item (click)="rowActions(rowIndex)">
            @if (menu.key === 'hide') {
            <i
                class="fa-regular {{((menu.key === 'hide' && aliasMenuItems.isHide) ? 'fa-eye-slash' : menu.iconClass)}}"></i>
            {{ (menu.key === 'hide' && aliasMenuItems.isHide) ? 'Show Subtotal Desc' : 'Hide Subtotal Desc' }}

            } @else {
            <i class="fa-regular {{menu.iconClass}}"></i> {{ menu.value }}

            }
        </button>
        } @else if (((aliasMenuItems.type === rowTypes.GENERAL || aliasMenuItems.type === rowTypes.TEXT ||
        aliasMenuItems.type === rowTypes.SUBROW) && (menu.key === 'format' || menu.key === 'delete')) ||
        (aliasMenuItems.type === rowTypes.TEXT && menu.key === 'subrow')) {
        <button [disabled]="hasAnySubtotalChecked() && menu.key === 'format'" mat-menu-item
            (click)="rowActions(rowIndex)">
            <i class="fa-regular {{menu.iconClass}}"></i> {{ menu.value }}
        </button>
        }

        }
    </ng-template>
</mat-menu>


<!--column format options-->
<mat-menu #columnFormatOptions="matMenu" xPosition="before">
    @for ( action of columnActions; track action.key) {
    <button *ngIf="!(action.key === 'rename')" [matMenuTriggerFor]="action.subMenu.length ? subMenu : null"
        class="add-row-btn" [disabled]="action.key === 'delete' && scheduleDetails().columns?.length === 1"
        mat-menu-item>
        <i class="fa-regular {{action.iconClass}}"></i>
        <div (click)="!action.subMenu.length && applyColumnFormat(action, null)"
            class="flexbox-row gap-8 justify-content-between">
            <span class="button-label">{{ action.value }}</span>
        </div>
    </button>
    <mat-menu #subMenu="matMenu">
        @for (subItem of action.subMenu; track subItem.key) {
        <button class="add-row-btn" mat-menu-item [disabled]="selectedIndex().defaultDateFormat === subItem.key">
            <div (click)="applyColumnFormat(action, subItem)" class="flexbox-row gap-8 justify-content-between">
                <span class="button-label">{{ subItem.name }}</span>
            </div>
        </button>
        }
    </mat-menu>
    }
</mat-menu>


<!--mat menu for add new row-->
<mat-menu #matAddNewRow="matMenu">
    <ng-template matMenuContent let-aliasGroupIndex="groupIndex">
        @for (menu of addRowMenu; track menu.key; let rowIndex = $index) {
        <button [matMenuTriggerFor]="menu.subMenu.length ? subMenu : null" class="add-row-btn" mat-menu-item>
            <div (click)="!menu?.subMenu?.length && addNewRow(rowIndex, null, aliasGroupIndex)"
                class="flexbox-row gap-8 justify-content-between">
                <span class="button-label">{{ menu.value }}</span>
            </div>
        </button>
        <mat-menu #subMenu="matMenu">
            @for (subItem of menu.subMenu; track subItem.key; let subRowIndex = $index) {
            <button (click)="addNewRow(rowIndex, subRowIndex, aliasGroupIndex)" class="add-row-btn" mat-menu-item>
                <div class="flexbox-row gap-8 justify-content-between">
                    <span class="button-label">{{ subItem.value }}</span>
                </div>
            </button>
            }
        </mat-menu>
        }
    </ng-template>
</mat-menu>


<!--search TB records-->
<mat-menu #matSearchForm="matMenu" (closed)="onMenuClosed()" class="trial-menu max-w-initial">
    <ng-template matMenuContent let-groupIndex="groupIndex" let-rowIndex="rowIndex" >
        <div class="flexbox-row justify-content-end p-2">
            <button mat-button color="error" class="button-text">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div style="max-height: 400px; overflow-y: auto;">
            <table *ngIf="filteredTrialBalData()?.length > 0 else noDataFound" class="mat-table table-countable">
                <thead>
                    <tr class="mat-header-row sticky-item">
                        <th class="des-column serach-tb-des">Description</th>
                        <th class="">Final</th>
                        <th class="">PY1</th>
                        <th class="">PY2</th>
                    </tr>
                </thead>
                <tbody>
                    @for (trial of filteredTrialBalData(); track trial) {
                    @if (searchControl.value ? (trial.isSearched && !trial.isHide) : !trial.isHide) {
                    <tr (click)="onSelectedTbRecord(trial, groupIndex, rowIndex )">
                        <td class="serach-tb-des" title="{{ trial.description }}">{{ trial.description }}</td>
                        <td>{{
                            trial.currYearValue | formattedNumber
                            }}
                        </td>
                        <td>{{
                            trial.prevYearValue | formattedNumber
                            }}
                        </td>
                        <td>{{
                            trial.prevYear2Value | formattedNumber
                            }}
                        </td>
                    </tr>
                    }
                    }

                </tbody>
            </table>
        </div>
        <ng-template #noDataFound>
            <div class="no-data-found">
                <img ngSrc="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon" height="120"
                    width="160">
                <h6>No records found!</h6>
            </div>
        </ng-template>
    </ng-template>

</mat-menu>
